import type { TFunction } from 'i18next';
import { OPENX_AGENT_TOOL } from '../Home/utils/consts';
import type { OpenXAgentTool } from '../Home/utils/types';
import type { OpenXAgentConfig, OpenXAgentId } from './types';

export const AGENT_TOOL_IDS: Record<OpenXAgentId, OpenXAgentTool> = {
  'deal-prompt': OPENX_AGENT_TOOL.DEAL_PROMPT,
  'targeting-check': OPENX_AGENT_TOOL.TARGETING_EXPLAINER,
  troubleshooter: OPENX_AGENT_TOOL.TROUBLESHOOTER,
};

export const getAgents = (t: TFunction): OpenXAgentConfig[] => [
  {
    id: 'deal-prompt',
    name: t('Deal Prompt'),
    description: t('Create new deals and structure tailored audience segments from scratch.'),
  },
  {
    id: 'targeting-check',
    name: t('Targeting Check'),
    description: t('Decode targeting parameters into clear metrics and buyer personas.'),
  },
  {
    id: 'troubleshooter',
    name: t('Troubleshooter'),
    description: t('Detect delivery blockers and fix setup errors in real time.'),
  },
];
